export default __webpack_public_path__ + "static/label_white_rgb-aa8115fbdbcd64ee83fa7438e6fa41bf.svg";